import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import Err from "@Broker/@Routes/error";
import { REPORT_TYPE_E } from "@Broker/@Types/reports/types";
import { getNrOfUnsyncedApplications, getReportFile, getReportHistory, runTheReport } from "./reports-api";
import { clearToast, showToast } from "@Shared/@Utils/constants";
import { encode64 } from "@Broker/js/custom/utils";
import { SET_RESPONSE_MESSAGE, SET_REPORTS_HISTORY_LOADER } from "./reports-mutations";
import { GET_REPORTS_HISTORY_LOADING_STATE } from "@Broker/js/modules/clients/reports/store/reports-getters";
import { delay } from "@Shared/@Utils/utils";
import Amplitude from "@Shared/@Utils/amplitude";
export const RESET_APPLICATION_SUMMARY_TO_DEFAULT = "RESET_APPLICATION_SUMMARY_TO_DEFAULT";
export const SET_APPLICATION_SUMMARY_DEFAULT = "SET_APPLICATION_SUMMARY_DEFAULT";
export const RUN_APPLICATION_SUMMARY_REPORT = "RUN_APPLICATION_SUMMARY_REPORT";
export const SAVE_RENEWAL_TRACKING_REPORT_DEFAULT = "SAVE_RENEWAL_TRACKING_REPORT_DEFAULT";
export const RUN_RENEWAL_TRACKING_REPORT = "RUN_RENEWAL_TRACKING_REPORT";
export const RUN_COMMISSIONS_REPORT = "RUN_COMMISSIONS_REPORT";
export const UPDATE_FIRM_STATISTICS_DEFAULT_VALUES = "UPDATE_FIRM_STATISTICS_DEFAULT_VALUES";
export const RUN_FIRM_STATISTICS_REPORT = "RUN_FIRM_STATISTICS_REPORT";
export const SAVE_LENDER_TRANSACTION_REPORT_DEFAULT = "SAVE_LENDER_TRANSACTION_REPORT_DEFAULT";
export const RUN_LENDER_TRANSACTION_REPORT = "RUN_LENDER_TRANSACTION_REPORT";
export const LOAD_REPORTS_HISTORY = "LOAD_REPORTS_HISTORY";
export const DOWNLOAD_REPORT_BY_ID = "DOWNLOAD_REPORT_BY_ID";
export const NO_DATA_RETRIEVED = "NO_DATA_RETRIEVED";
export const SUCCESSFUL_DATA_RETRIEVED = "SUCCESSFUL_DATA_RETRIEVED";
export const FETCH_NR_UNSYNCED_APPLICATIONS = "FETCH_NR_UNSYNCED_APPLICATIONS";
export const RUN_RISK_LEVEL_REPORT = "RUN_RISK_LEVEL_REPORT";
const waitForWebsocket = context => {
  setTimeout(() => {
    if (context.state.responseMessage === "") {
      showToast("info", "notificationReportGeneration", "", {
        timeOut: 5000
      });
      context.commit(SET_RESPONSE_MESSAGE, "waiting");
    } else {
      if (context.state.responseMessage !== "waiting") {
        context.commit(SET_RESPONSE_MESSAGE, "");
      }
    }
  }, 5000);
};
const actions = {
  [RUN_FIRM_STATISTICS_REPORT]: async (context, firmStatisticsReport) => {
    try {
      const {
        selectedAgents: agents,
        selectedFormat: format,
        selectedLevel: level,
        dateFrom,
        dateTo,
        dateType,
        selectedApplicationStatus: applicationStatus,
        filterForAIR: annualInformationReturn
      } = firmStatisticsReport;
      const args = {
        agents,
        level,
        dateFrom,
        dateTo,
        applicationStatus,
        dateType,
        annualInformationReturn
      };
      const {
        pending
      } = await getNrOfUnsyncedApplications({
        format,
        reportType: REPORT_TYPE_E.FIRM_STATISTICS,
        args
      });
      if (pending == 0) {
        waitForWebsocket(context);
        await runTheReport({
          format,
          reportType: REPORT_TYPE_E.FIRM_STATISTICS,
          args
        });
        Amplitude.logEvent("Reports - Firm Statistics: Request to generate report successful");
        Amplitude.updateCount("Reports - Firm Statistics");
        return {
          succeeded: true,
          pending
        };
      } else {
        return {
          succeeded: false,
          pending
        };
      }
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [RUN_RISK_LEVEL_REPORT]: async (context, riskLevelReport) => {
    try {
      const {
        selectedAgents: agents,
        selectedFormat: format,
        selectedLevel: level,
        dateFrom,
        dateTo,
        dateType,
        selectedApplicationStatus: applicationStatus,
        selectedRiskLevels: riskLevels
      } = riskLevelReport;
      const args = {
        agents,
        level,
        dateFrom,
        dateTo,
        applicationStatus,
        dateType,
        riskLevels
      };
      const {
        pending
      } = await getNrOfUnsyncedApplications({
        format,
        reportType: REPORT_TYPE_E.RISK_LEVEL,
        args
      });
      if (pending == 0) {
        waitForWebsocket(context);
        await runTheReport({
          format,
          reportType: REPORT_TYPE_E.RISK_LEVEL,
          args
        });
        Amplitude.logEvent("Reports - Firm Statistics: Request to generate report successful");
        Amplitude.updateCount("Reports - Firm Statistics");
        return {
          succeeded: true,
          pending
        };
      } else {
        return {
          succeeded: false,
          pending
        };
      }
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [RUN_RENEWAL_TRACKING_REPORT]: async (context, renewalTrackingReport) => {
    try {
      const {
        level,
        agent: agents,
        lender,
        mortgageType,
        requestType,
        dateFrom: maturityDateFrom,
        dateTo: maturityDateTo,
        groupBy,
        sortBy: [sortByPrimary, sortBySecondary],
        format
      } = renewalTrackingReport;
      const args = {
        agents,
        level,
        maturityDateFrom,
        maturityDateTo,
        lender,
        mortgageType,
        requestType,
        groupBy,
        sortByPrimary,
        sortBySecondary
      };
      const {
        pending
      } = await getNrOfUnsyncedApplications({
        format,
        reportType: REPORT_TYPE_E.RENEWAL_TRACKING,
        args
      });
      if (pending == 0) {
        waitForWebsocket(context);
        await runTheReport({
          format,
          reportType: REPORT_TYPE_E.RENEWAL_TRACKING,
          args
        });
        Amplitude.logEvent("Reports - Renewal Tracking: Request to generate report successful");
        Amplitude.updateCount("Reports - Renewal Tracking");
        return {
          succeeded: true,
          pending
        };
      } else {
        return {
          succeeded: false,
          pending
        };
      }
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [RUN_APPLICATION_SUMMARY_REPORT]: async (context, applicationSummaryReport) => {
    try {
      const {
        pending
      } = await getNrOfUnsyncedApplications({
        format: applicationSummaryReport.format,
        reportType: REPORT_TYPE_E.APPLICATIONS_SUMMARY,
        args: applicationSummaryReport
      });
      if (pending == 0) {
        waitForWebsocket(context);
        await runTheReport({
          format: applicationSummaryReport.format,
          reportType: REPORT_TYPE_E.APPLICATIONS_SUMMARY,
          args: applicationSummaryReport
        });
        Amplitude.logEvent("Reports - Applications Summary: Request to generate report successful");
        Amplitude.updateCount("Reports - Applications Summary");
        return {
          succeeded: true,
          pending
        };
      } else {
        return {
          succeeded: false,
          pending
        };
      }
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [RUN_LENDER_TRANSACTION_REPORT]: async (context, lenderTransactionReport) => {
    try {
      const {
        format
      } = lenderTransactionReport;
      const args = _objectSpread(_objectSpread({}, lenderTransactionReport), {}, {
        agents: lenderTransactionReport.agent,
        sortByPrimary: lenderTransactionReport.sortBy[0],
        sortBySecondary: lenderTransactionReport.sortBy[1],
        annualInformationReturn: lenderTransactionReport.filterForAIR
      });
      const {
        pending
      } = await getNrOfUnsyncedApplications({
        format,
        reportType: REPORT_TYPE_E.LENDER_TRANSACTIONS,
        args
      });
      if (pending == 0) {
        waitForWebsocket(context);
        await runTheReport({
          format,
          reportType: REPORT_TYPE_E.LENDER_TRANSACTIONS,
          args
        });
        Amplitude.logEvent("Reports - Lender Transactions: Request to generate report successful");
        Amplitude.updateCount("Reports - Lender Transactions");
        return {
          succeeded: true,
          pending
        };
      } else {
        return {
          succeeded: false,
          pending
        };
      }
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [RUN_COMMISSIONS_REPORT]: async (context, commissionsReport) => {
    try {
      const payload = {
        reportType: REPORT_TYPE_E.COMMISSIONS,
        format: commissionsReport.format,
        args: commissionsReport
      };
      const {
        pending
      } = await getNrOfUnsyncedApplications(payload);
      const succeeded = pending <= 0;
      if (succeeded) {
        waitForWebsocket(context);
        await runTheReport(payload);
        Amplitude.logEvent("Reports - Commissions: Request to generate report successful");
        Amplitude.updateCount("Reports - Commissions");
      }
      return {
        succeeded,
        pending
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [FETCH_NR_UNSYNCED_APPLICATIONS]: async (context, reportPyaload) => {
    try {
      const {
        pending
      } = await getNrOfUnsyncedApplications({
        format: reportPyaload.format,
        reportType: REPORT_TYPE_E.APPLICATIONS_SUMMARY,
        args: reportPyaload
      });
      return pending;
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [LOAD_REPORTS_HISTORY]: async (context, pagination) => {
    try {
      const {
        agentUsernames,
        reportTypes
      } = pagination;
      const base64AgentUsernames = agentUsernames != null && agentUsernames.length ? encode64(_JSON$stringify(agentUsernames)) : undefined;
      const base64ReportTypes = reportTypes != null && reportTypes.length ? encode64(_JSON$stringify(reportTypes)) : undefined;
      const {
        reportHistory
      } = await getReportHistory(_objectSpread(_objectSpread({}, pagination), {}, {
        agentUsernames: base64AgentUsernames,
        reportTypes: base64ReportTypes
      }));
      if (context.getters[GET_REPORTS_HISTORY_LOADING_STATE]) {
        context.commit(SET_REPORTS_HISTORY_LOADER, false);
      }
      return reportHistory;
    } catch (e) {
      Err.handle(e);
      return [];
    }
  },
  [DOWNLOAD_REPORT_BY_ID]: async (context, {
    reportId
  }) => {
    try {
      const {
        signedFileOptions
      } = await getReportFile(reportId);
      return signedFileOptions;
    } catch (e) {
      Err.handle(e);
    }
  },
  [SUCCESSFUL_DATA_RETRIEVED]: async (context, {
    results
  }) => {
    if (results) {
      context.commit(SET_REPORTS_HISTORY_LOADER, true);
      context.dispatch(LOAD_REPORTS_HISTORY, {
        offset: 0,
        limit: 7,
        orderBy: "requestedAt",
        orderType: "DESC",
        agentUsernames: undefined,
        reportTypes: undefined
      });
      clearToast();
      await delay(600);
      context.commit(SET_RESPONSE_MESSAGE, "success");
      showToast("success", "successfulDataRetrieved");
    }
  },
  [NO_DATA_RETRIEVED]: async (context, {
    results
  }) => {
    if (!results) {
      clearToast();
      await delay(600);
      context.commit(SET_RESPONSE_MESSAGE, "error");
      showToast("error", "noDataRetrieved");
    }
  }
};
export default actions;